import React from 'react';

import Button from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import CustomDropdown from '../../../../components/DropDown';
import Loader from '../../../../components/Loader';
import Modal from '../../../../components/Model';
import { formatDate, formatTime, months, Roles, styles } from '../../../../util/constant';
import LeaveBalance from '../../../Employee/Leave/Components/LeaveBalance';
import useLeave from '../useLeave';

const Leave: React.FC = () => {
  const Role = localStorage.getItem("role");

  const {
    leaveData,
    showConfirmation,
    handleCancelStatusUp,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
    years,
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth,
    userLeave: leaveBalance,
    user,
    userId,
    setUserId,
    handleSelectStatus,
    showModal,
    handleModalClose,
    handleModalSubmit,
    description,
    setDescription,
    handleAddNewYearClick,
    handleAddNewYearConfirm,
    handleAddNewYearCancel,
    showAddYearConfirmation,
    showDownloadModal,
    downloadYear,
    setDownloadYear,
    downloadUserId,
    setDownloadUserId,
    handleDownloadCSV,
    handleOpenDownloadModal,
    handleCloseDownloadModal,
  } = useLeave();

  const columns: Column[] = [
    {
      field: "userId",
      headerName: "User",
      width: 50,
      align: "center",
      renderCell: (params: any) => <p>{params.value.name}</p>,
    },
    {
      field: "type",
      headerName: "Leave Type",
      width: 50,
      align: "center",
    },
    {
      field: "subtype",
      headerName: "Sub Type",
      width: 50,
      align: "center",
    },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    {
      field: "paidDays",
      headerName: "paid Days",
      width: 50,
      align: "center",
    },
    {
      field: "unpaidDays",
      headerName: "unpaid Days",
      width: 50,
      align: "center",
    },
    {
      field: "totalDays",
      headerName: "Total Days",
      width: 50,
      align: "center",
    },
    {
      field: "fromDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "From",
      align: "center",
      width: 50,
    },
    {
      field: "toDate",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "To",
      align: "center",
      width: 50,
    },
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "Requested Date",
      align: "center",
      width: 50,
    },
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatTime(params.value)}</p>,
      headerName: "Requested Time",
      align: "center",
      width: 50,
    },
    {
      field: "Actions",
      renderCell: (params: any) => (
        <div className={styles[params.row.status] || "bg-gray-200 "}>
          <select
            defaultValue={params.row.status}
            onChange={(event) => handleSelectStatus(event, params.row)}
            className="appearance-none  bg-transparent outline-none w-full cursor-pointer font-semibold"
          >
            <option value="pending">pending</option>
            <option value="approve">approve</option>
            <option value="reject">reject</option>
          </select>
        </div>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    {
      field: "comments",
      headerName: "Comment",
      width: 50,
      align: "center",
    },
  ];

  return (
    <div>
      <div className="m-5 h-[80vh] overflow-y-auto">
        {loading && <Loader />}
        <div>
          <>
            {userId && (
              <LeaveBalance
                remainingPaidLeave={leaveBalance?.remainingPaidLeave}
                totalPaidLeave={leaveBalance?.totalPaidLeave}
                totalTakenLeave={leaveBalance?.totalTakenLeave}
                totalUnPaidLeave={leaveBalance?.totalUnPaidLeave}
              />
            )}
            <div className="grid justify-items-end mr-5 space-y-2">
              {Role === Roles.admin && (
                <>
                  <Button
                    onClick={handleAddNewYearClick}
                    className="p-2 rounded-lg"
                    children="Add New Year"
                    type="button"
                  />
                  <Button
                    onClick={handleOpenDownloadModal}
                    className="p-2 rounded-lg bg-green-600 hover:bg-green-700"
                    children="Download CSV"
                    type="button"
                  />
                </>
              )}
            </div>
            <div className="flex items-center space-x-4 mb-4">
              <CustomDropdown
                label="Year"
                options={years.map((year) => ({
                  id: year,
                  value: year,
                  label: year.replace("-", " - "),
                }))}
                defaultOptionId={selectedYear}
                setDefaultOptionId={setSelectedYear}
                displayProperty="label"
                value={selectedYear}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
              />
              <CustomDropdown
                label="Month"
                options={months.map((month: any) => ({
                  id: month.value,
                  ...month,
                }))}
                defaultOptionId={selectedMonth}
                setDefaultOptionId={setSelectedMonth}
                displayProperty="label"
                value={selectedMonth}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
              />
              <CustomDropdown
                label="User"
                options={user}
                defaultOptionId={userId || ""}
                setDefaultOptionId={setUserId}
                displayProperty="name"
                value={userId || ""}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
              />
            </div>

            <CommonDataGrid
              tableName="Leave"
              rows={leaveData}
              columns={columns}
              getRowId={(row) => row._id}
              showConfirmation={showConfirmation}
              confirmationMessage="Are you sure you want to Status Update this Leave?"
              onCancelDelete={handleCancelStatusUp}
              onConfirmDelete={() => {}}
              loading={!leaveData}
              setSearchBar={setSearch}
              setCurrentPage={setPage}
              currentPage={page}
              totalPages={totalPage}
              dayFilter={false}
              searchFilter={false}
              downloadCSVFilter={false}
            />
          </>
        </div>
      </div>
      {showModal && (
        <Modal isOpen={showModal} onClose={handleModalClose}>
          <div className="p-4">
            <textarea
              className="w-full p-2 border rounded"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
            />
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-100"
                onClick={handleModalClose}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                onClick={handleModalSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      )}

      {showAddYearConfirmation && (
        <Modal
          isOpen={showAddYearConfirmation}
          onClose={handleAddNewYearCancel}
        >
          <div className="p-4">
            <h3 className="text-lg font-semibold mb-4">Confirm Add New Year</h3>
            <p className="mb-4">
              Are you sure you want to add a new year? This action cannot be
              undone.
            </p>
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-100"
                onClick={handleAddNewYearCancel}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                onClick={handleAddNewYearConfirm}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}

      {showDownloadModal && (
        <Modal isOpen={showDownloadModal} onClose={handleCloseDownloadModal}>
          <div className="p-4">
            <h3 className="text-lg font-semibold mb-4">Download Leave Data</h3>
            <div className="space-y-4">
              <CustomDropdown
                label="Year"
                options={years.map((year) => ({
                  id: year,
                  value: year,
                  label: year.replace("-", " - "),
                }))}
                defaultOptionId={downloadYear}
                setDefaultOptionId={setDownloadYear}
                displayProperty="label"
                value={downloadYear}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
              />
              <CustomDropdown
                label="User (Optional)"
                options={user}
                defaultOptionId={downloadUserId || ""}
                setDefaultOptionId={setDownloadUserId}
                displayProperty="name"
                value={downloadUserId || ""}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor"
              />
            </div>
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-100"
                onClick={handleCloseDownloadModal}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700"
                onClick={handleDownloadCSV}
              >
                Download
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Leave;
